import { useInputClassname } from '@elements/input-container'
import {
  PhoneInput as InternationalPhoneInput,
  PhoneInputProps as InternationalPhoneInputProps,
} from 'react-international-phone'
import { Statused } from 'types/ui'

export type PhoneInputProps = InternationalPhoneInputProps & Statused & {}

export function PhoneInput({
  defaultCountry = 'us',
  value = '',
  className,
  success,
  warning,
  error,
  ...phoneInputProps
}: PhoneInputProps) {
  const inputClassname = useInputClassname({
    className,
    success,
    warning,
    error,
    hasValue: !!value,
    regular: true,
  })

  return (
    <InternationalPhoneInput
      {...phoneInputProps}
      defaultCountry={defaultCountry}
      className={inputClassname}
      value={value}
    />
  )
}
